import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Location } from "../../services/api";
import { getLocationsAsAntDTree, parseToAntDTree } from "../../utils";
import { TreeSelect } from "../TreeSelect";
import { jsx as _jsx } from "react/jsx-runtime";
const TreeSelectLocationComponent = props => {
    const { t } = useTranslation();
    const { locations, disabledNodes = [], disableWholeTree = true, treeDataSimpleMode = true, showPath, multiple = false, placeholder, ...restProps } = props;
    const resolvedPlaceholder = placeholder ?? t('FormBuilder.LocationPlaceholder');
    const [treeData, setTreeData] = useState([]);
    useEffect(() => {
        const fetchTreeData = async () => {
            if (locations && locations.length > 0) {
                setTreeData(locations);
            }
            else {
                const fetchedTree = await getLocationsAsAntDTree(disabledNodes, disableWholeTree, true);
                setTreeData(fetchedTree);
            }
        };
        if (treeData.length == 0)
            fetchTreeData();
    }, [locations, disabledNodes, disableWholeTree]); // Dependências do useEffect
    return /*#__PURE__*/ _jsx(TreeSelect, {
        ...restProps,
        treeData: treeData,
        placeholder: resolvedPlaceholder,
        treeDataSimpleMode: treeDataSimpleMode,
        showPath: showPath,
        multiple: multiple
    });
};
export const TreeSelectLocationBase = props => {
    const { baseLocation, languageId, includeDirectParents = true, disabledNodes = [], disableWholeTree = true, multiple = false } = props;
    const getTree = React.useCallback(async () => {
        if (baseLocation) {
            const response = await Location.get(baseLocation, languageId, true, includeDirectParents);
            return parseToAntDTree([response.data.response], disabledNodes, disableWholeTree, false, true);
        }
    }, [baseLocation, languageId, includeDirectParents, disabledNodes, disableWholeTree]);
    return /*#__PURE__*/ _jsx(TreeSelectLocationComponent, {
        getTree: getTree,
        multiple: multiple,
        ...props
    });
};
export const TreeSelectLocation = /*#__PURE__*/ React.memo(TreeSelectLocationComponent);
export { TreeSelectLocationCompany } from "./company";
export { TreeSelectLocationUser } from "./user";
